// JavaScript to change text dynamically on mobile view with line break
/*document.addEventListener("DOMContentLoaded", function() {
  function updateText() {
    var contactUsElement = document.getElementById("HeaderDrawer-contact-us");

    if (contactUsElement) {
      if (window.innerWidth <= 989) {
        contactUsElement.innerHTML = "Ordering/<br>Contact Us";
      } else {
        contactUsElement.textContent = "Contact Us";
      }
    }
  }
  updateText();
  window.addEventListener('resize', updateText);
});*/
////////////////////////
const swiper = new Swiper('#t-image-carousel', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 1,
  loop: true,
  clickable: true,
  effect: "fade",
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

/*****Product Recommend Carousel******/
const tProductRecommend = new Swiper('#t-recomm-prod-carousel', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 5,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
const tSauceProductRecommend = new Swiper('#t-recomm-sauce-prod-carousel', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 4,
  slidesPerColumn: 2,
  autoplay: {
    delay: 3000,
  },
    breakpoints: {
    
    768: {
      // slidesPerView: 3,
      // spaceBetween: 30
      slidesPerView: 8,
      slidesPerColumn: 1,
    },
    }
});

const tReviewsCarousel = new Swiper('#t-reviews-carousel', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  clickable: true,
  slidesPerView: 1,
  spaceBetween: 31,
  // autoplay: {
  //   delay: 3000,
  // },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: 2,
      spaceBetween: 55
    },
  }
});


// starts as X away from minimum and then switches to X away from free shipping.
document.addEventListener("DOMContentLoaded", function () {
  var minimumOrder = 30;
  var freeShippingThreshold = 50;
  var previousTotal = 0;

  // Message elements
  var pageMessageEl = document.getElementById("cart-status-message--page");
  var drawerMessageEl = document.getElementById("cart-status-message--drawer");

  // Buttons
  var checkoutBtn = document.getElementById("checkout");
  var drawerForm = document.getElementById("cart-notification-form");
  var drawerCheckoutBtn = drawerForm?.querySelector('button[name="checkout"]');

  function setCheckoutState(enabled) {
    if (checkoutBtn) {
      checkoutBtn.disabled = !enabled;
      checkoutBtn.style.opacity = enabled ? "1" : "0.5";
      checkoutBtn.style.cursor = enabled ? "pointer" : "not-allowed";
      // checkoutBtn.style.pointerEvents = enabled ? "auto" : "none";
    }
    if (drawerCheckoutBtn) {
      drawerCheckoutBtn.disabled = !enabled;
      drawerCheckoutBtn.style.opacity = enabled ? "1" : "0.5";
      // drawerCheckoutBtn.style.cursor = enabled ? "pointer" : "not-allowed";
    }
  }

  function updateCartMessage(cartTotal) {
    let message = "";

    if (cartTotal < minimumOrder) {
      let difference = (minimumOrder - cartTotal).toFixed(2);
      message = `You’re <span style="color: #901718;">$${difference}</span> away from the <span style="color: #000;">$${minimumOrder}</span> minimum order.`;
      setCheckoutState(false); // final disable

    } 
    else {
      setCheckoutState(true);
    }
    // else if (cartTotal >= minimumOrder && cartTotal < freeShippingThreshold) {
    //   let difference = (freeShippingThreshold - cartTotal).toFixed(2);
    //   message = `You’re <span style="color: #a32722;">$${difference}</span> away from Free Shipping`;
    //   setCheckoutState(true); 

    // } else if (cartTotal >= freeShippingThreshold) {
    //   message = `<span style="color: #a32722;">🎉 You’ve unlocked Free Shipping!</span>`;
    //   setCheckoutState(true); 
    // }

    if (pageMessageEl) pageMessageEl.innerHTML = message;
    if (drawerMessageEl) drawerMessageEl.innerHTML = message;
  }

  function checkCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        var cartTotal = data.total_price / 100;
        if (cartTotal !== previousTotal) {
          previousTotal = cartTotal;
          updateCartMessage(cartTotal);
        }
      });
  }

  // ✅ Initial check
  checkCart();

  // ✅ Quantity change → instant disable, then fetch final state
  document.addEventListener("input", function (e) {
    if (e.target.matches('.quantity__input')) {
      setCheckoutState(false); // instant disable
      setTimeout(checkCart, 200); // cart.js fetch ke baad final state
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest('.quantity__button')) {
      setCheckoutState(false); // instant disable
      setTimeout(checkCart, 200); // cart.js fetch ke baad final state
    }
  });

  // ✅ Optional: auto-refresh every 5–10 sec
  setInterval(checkCart, 1000);
});


// You are X away from free shipping
// document.addEventListener("DOMContentLoaded", function () {
//   var freeShippingThreshold = 125;
//   var pageMessageEl = document.getElementById("free-shipping-message");
//   var drawerMessageEl = document.getElementById("free-shipping-message--drawer");

//   function updateFreeShippingMessage(cartTotal) {
//     var message = "";

//     if (cartTotal >= freeShippingThreshold) {
//       message = `<span style="color: #a32722;">🎉 You’ve unlocked Free Shipping!</span>`;
//     } else {
//       var difference = (freeShippingThreshold - cartTotal).toFixed(2);
//       message = `You’re <span style="color: #a32722;">$${difference}</span> away from Free Shipping`;
//     }

//     if (pageMessageEl) pageMessageEl.innerHTML = message;
//     if (drawerMessageEl) drawerMessageEl.innerHTML = message;
//   }

//   function checkCartTotal() {
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(data => {
//         var cartTotal = data.total_price / 100;
//         updateFreeShippingMessage(cartTotal);
//       });
//   }

//   checkCartTotal();
//   setInterval(checkCartTotal, 1000);
// });


//Minimum Order value based text - disable checkout
// document.addEventListener("DOMContentLoaded", function () {
//   var previousTotal = 0;
//   var minimum = 50;

//   function updateMessage(cartTotal) {
//     var pageMessage = document.getElementById("min-order-message--page");
//     var drawerMessage = document.getElementById("min-order-message--drawer");

//     var checkoutBtn = document.getElementById("checkout");

//     var drawerForm = document.getElementById("cart-notification-form");
//     var drawerCheckoutBtn = drawerForm?.querySelector('button[name="checkout"]');
    
//     let message = "";

//     if (cartTotal < minimum) {
//       let difference = (minimum - cartTotal).toFixed(2);
//       message = `You’re <span style="color: #901718;">$${difference}</span> away from the <span style="color: #000;">$${minimum}</span> minimum order.`;

//       if (checkoutBtn) {
//         checkoutBtn.disabled = true;
//         checkoutBtn.style.opacity = "0.5";
//         checkoutBtn.style.cursor = "not-allowed";
//       }
//       if (drawerCheckoutBtn) {
//         drawerCheckoutBtn.disabled = true;
//         drawerCheckoutBtn.style.opacity = "0.5";
//         drawerCheckoutBtn.style.cursor = "not-allowed";
//       }
//     } else {
//       message = `<span style="color: #5f6f4a;">Great! You’re eligible to checkout.</span>`;

//       if (checkoutBtn) {
//         checkoutBtn.disabled = false;
//         checkoutBtn.style.opacity = "1";
//         checkoutBtn.style.cursor = "pointer";
//       }
//       if (drawerCheckoutBtn) {
//         drawerCheckoutBtn.disabled = false;
//         drawerCheckoutBtn.style.opacity = "1";
//         drawerCheckoutBtn.style.cursor = "pointer";
//       }
//     }

//     if (pageMessage) pageMessage.innerHTML = message;
//     if (drawerMessage) drawerMessage.innerHTML = message;
//   }

//   function checkCart() {
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(data => {
//         var cartTotal = data.total_price / 100;
//         if (cartTotal !== previousTotal) {
//           previousTotal = cartTotal;
//           updateMessage(cartTotal);
//         }
//       });
//   }

//   checkCart();
//   setInterval(checkCart, 500);
// });